<template>
  <v-container class="px-12">
    <v-row>
      <v-col cols="12" lg="6">
        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.state") }} :
            </span>

            <span class="dialog-content-text">
              <span v-if="computedData.status === 0">
                {{ $t("texts.statecandidatetooltip") }}
                <v-icon color="grey darken-2">mdi-circle</v-icon>
              </span>
              <span v-else-if="computedData.status === 1">
                {{ $t("texts.stateserializationtooltip") }}
                <v-icon color="grey darken-1">mdi-circle</v-icon>
              </span>
              <span v-else-if="computedData.status === 2">
                {{ $t("texts.stateprerealizationtooltip") }}
                <v-icon color="grey">mdi-circle</v-icon>
              </span>
              <span v-else-if="computedData.status === 3">
                {{ $t("texts.staterealizationtooltip") }}
                <v-icon color="green lighten-1">mdi-circle</v-icon>
              </span>
              <span v-else-if="computedData.status === 4">
                {{ $t("texts.stateterminatedtooltip") }}
                <v-icon color="red lighten-1">mdi-circle</v-icon>
              </span>
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.contactPerson") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.contactPerson }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.county") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.county }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.email") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.email }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.perfilPhone") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.mobileNumber }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.targetaudience") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.targetAudience }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.projectsummary") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.description }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.specificRequirement") }} :
            </span>

            <span class="dialog-content-text">
              {{
                computedData.trainingRequirement
                  ? computedData.trainingRequirement
                  : this.$t("texts.no")
              }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title  font-weight-bold">
              {{ $t("texts.interventionareas") }} :
            </span>

            <span class="dialog-content-text">
              {{ computedData.interventionArea }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title  font-weight-bold">
              {{ $t("texts.volunteersecure") }} :
            </span>

            <span
              v-if="computedData.safeYesOrNo === '0'"
              class="dialog-content-text"
            >
              {{ $t("texts.yes") }}
            </span>

            <span
              v-if="computedData.safeYesOrNo === '1'"
              class="dialog-content-text"
            >
              {{ $t("texts.no") }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title  font-weight-bold">
              {{ $t("texts.activitiesdescription") }} :
            </span>

            <v-textarea
              v-model="computedData.activitiesDescription"
              hide-details="auto"
              :row-height="24"
              :rows="4"
              outlined
              readonly
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.perfilAreasOfInterest") }} :
            </span>

            <v-textarea
              v-model="computedData.requiredInterestAreas"
              hide-details="auto"
              :row-height="24"
              :rows="4"
              outlined
              readonly
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.entitiesEnvolved") }} :
            </span>

            <v-textarea
              v-model="computedData.envolvedEntities"
              hide-details="auto"
              :row-height="24"
              :rows="4"
              outlined
              readonly
            ></v-textarea>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" lg="6">
        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title  font-weight-bold">
              {{ $t("texts.objectives") }} :
            </span>

            <v-textarea
              v-model="computedData.objectives"
              hide-details="auto"
              :row-height="24"
              :rows="4"
              outlined
              readonly
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.lastObservations") }} :
            </span>
            <v-textarea
              v-model="computedData.comments"
              hide-details="auto"
              :row-height="24"
              :rows="5"
              outlined
              readonly
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span class="dialog-content-title font-weight-bold">
              {{ $t("texts.shifts") }} :
            </span>
            <v-data-table
              :headers="timeSlotsHeaders"
              :items="computedData.timeSlots"
              item-key="_id"
              :sort-by="['date', 'startTime']"
              :sort-desc="[false, false]"
              group-by="date"
              :group-desc="false"
              :items-per-page="5"
              multi-sort
              class="elevation-1"
            >
              <!-- Group Header -->
              <template
                v-slot:[`group.header`]="{
                  group,
                  items,
                  isOpen,
                  toggle
                }"
              >
                <td colspan="4" class="text-start">
                  <v-btn icon small class="ma-0" @click="toggle">
                    <v-icon>
                      {{ isOpen ? "mdi-minus" : "mdi-plus" }}
                    </v-icon>
                  </v-btn>
                  {{
                    $t("texts.timeSlotsGroupHeader", {
                      date: group,
                      timeSlotsLength: items.length,
                      totalTime: timeSlotsTotalTime(items)
                    })
                  }}
                </td>
              </template>
              <!-- !Group Header -->
              <!-- Customize Columns -->
              <template v-slot:[`item.totalTime`]="{ item }">
                <td class="text-start">
                  {{ formatMinutes(item.totalTime) }}
                </td>
              </template>

              <template v-slot:[`item.vacancies`]="{ item }">
                <td class="text-start">
                  {{ item.vacancies ? item.vacancies : "-" }}
                </td>
              </template>
              <!-- !Customize Columns -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "volunteering-detail-card",

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  methods: {
    /**
     * Get the interest areas
     * @param {string} areas - the interest areas.
     * @public
     */
    getInterestAreas(areas) {
      if (areas != null) {
        let theAreas = "";
        areas.forEach(areaId => {
          theAreas += this.$t("texts.volunteerareasofinterest." + areaId);

          if (areas.indexOf(areaId) + 1 < areas.length) theAreas += ", ";
        });
        return theAreas;
      }
      return null;
    },
    /**
     * Return minutes formatted in "10h 30m"
     * @public
     */
    formatMinutes(minutes) {
      const hours = Math.floor(minutes / 60);

      return hours + "h " + (minutes % 60) + "m";
    },
    /**
     * Time slots total time
     * @public
     */
    timeSlotsTotalTime(timeSlots) {
      let totalMinutes = 0;

      timeSlots.forEach(timeSlot => {
        totalMinutes += timeSlot.totalTime;
      });

      return this.formatMinutes(totalMinutes);
    }
  },

  computed: {
    /**
     * Check if volunteering has comments or interest areas.
     * @public
     */
    computedData() {
      if (this.data === null || Object.keys(this.data).length === 0) {
        return {};
      }

      let data = this.data;
      data.requiredInterestAreas = this.getInterestAreas(
        this.data.requiredInterestAreaIds
      );
      data.comments = this.data.comments
        ? this.data.comments
        : this.$t("texts.noObservations");
      return data;
    },

    /**
     * Time slots datatable headers
     */
    timeSlotsHeaders() {
      return [
        {
          text: this.$t("texts.date"),
          value: "date"
        },
        {
          text: this.$t("texts.startTimeSlot"),
          value: "startTime",
          groupable: false
        },
        {
          text: this.$t("texts.endTimeSlot"),
          value: "endTime",
          groupable: false
        },
        {
          text: this.$t("texts.totalTimeSlot"),
          value: "totalTime",
          groupable: false
        },
        {
          text: this.$t("texts.vacancies"),
          value: "vacancies",
          groupable: false
        }
      ];
    }
  }
};
</script>
